// ===================================================
// @/components/ui — the ONE entry point for shared components
// ===================================================
// docs/BRAND.md §Components — one home (2026-09-18). A screen imports every
// shared component from here, whether it lives in src/components/ui or in
// packages/ui (@gam/ui). Improve the component once → every screen gets it.
//
// Deliberately NOT re-exported: IconPicker — it pulls the full Lucide icon map
// and SettingsContext into every bundle that touches this barrel. Import it
// directly from "@/components/ui/IconPicker".

export { Button, type ButtonVariant, type ButtonSize } from "./Button";
export { ButtonGroup, ButtonGroupText, ButtonGroupSeparator } from "./ButtonGroup";
export { Input, type InputSize } from "./Input";
export { Badge, type BadgeIntent, type BadgeSize } from "./badge";
export { Skeleton, SkeletonCard } from "./Skeleton";
export { Tooltip } from "./Tooltip";
export { Dialog } from "./Dialog";
export { ConfirmDialog, type ConfirmTone } from "./ConfirmDialog";
export { Select, type SelectSize } from "./Select";
export { OptimizedImage } from "./OptimizedImage";
export { EmptyState, type EmptyStateProps, type EmptyStateTone } from "./EmptyState";
export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent } from "./Card";
export { ControlRoomCard } from "./ControlRoomCard";
export { CustomSelect, type SelectOption } from "./CustomSelect";
export { InfoTooltip } from "./InfoTooltip";
export { LensTabs, type LensTab } from "./LensTabs";
export { OverlayLayer, useAnchorRect, type AnchorRect } from "./OverlayLayer";
export { Tabs, TabsList, TabsTrigger, TabsContent } from "./tabs";

// @gam/ui — the package half of the library, re-exported so screens need one import.
export {
  Chip,
  StatusToggle,
  Field,
  inputCls,
  SectionCard,
  SectionDivider,
  StickyActionBar,
  FacetPane,
  ColumnBrowser,
  VERSION as GAM_UI_VERSION,
  type ChipProps,
  type StatusToggleProps,
  type FieldProps,
  type SectionCardProps,
  type StickyActionBarProps,
  type FacetPaneProps,
  type FacetValueRow,
  type ColumnBrowserProps,
  type ColumnBrowserPane,
} from "@gam/ui";
